import { AronAuditTranscript } from "../AronAuditView";

/**
 * Karta PODGLĄDU cudzej rozmowy w warsztacie ARON-a (audyt CEO+DEV).
 *
 * Osobny komponent od `AronTabPane` celowo: tamten wpina rozmowę w czat
 * (`useAronChat`, sygnały tury, komponowanie odpowiedzi) po endpointach ciętych
 * do zalogowanego użytkownika — na cudzym wątku każdy z nich zwróciłby 404, a
 * pisanie w cudzej rozmowie nie ma prawa się zdarzyć. Tu jest wyłącznie odczyt.
 */
export function AronAuditTabPane({
  convId,
  active,
}: {
  convId: string;
  active: boolean;
}) {
  return (
    <div
      className={active ? "flex min-h-0 min-w-0 flex-1 flex-col" : "hidden"}
      aria-hidden={!active}
    >
      <AronAuditTranscript id={convId} showNotice />
    </div>
  );
}
